import { oc } from '@orpc/contract';
import { listServiceEventsInputSchema, listServiceEventsOutputSchema } from '../schemas/history.schemas.js';
/** The vehicle's manual service history, newest event first. Evidence, never a cost (PP AC07). */
export const listServiceEventsContract = oc
    .route({
    method: 'GET',
    path: '/vehicles/{vehicleId}/history',
    tags: ['History'],
    summary: 'List the manual service history of a stock vehicle',
})
    .input(listServiceEventsInputSchema)
    .output(listServiceEventsOutputSchema);
//# sourceMappingURL=list-service-events.contract.js.map